import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription, interval, of } from 'rxjs';
import { catchError, startWith, switchMap } from 'rxjs/operators';
import { SmsService } from 'src/app/core/services/sms/sms.service';
import { WhatsAppConnectionStatus } from 'src/app/core/graphql/generated/gen-types';
import { PipeModule } from 'src/app/shared/pipes.module';

@Component({
	selector: 'app-connection-status',
	standalone: true,
	imports: [CommonModule, MatIconModule, MatTooltipModule, TranslateModule, PipeModule],
	templateUrl: './connection-status.component.html',
	styleUrl: './connection-status.component.scss',
})
export class ConnectionStatusComponent implements OnInit, OnDestroy {
	connectionStatus: WhatsAppConnectionStatus | null = null;
	loading = true;
	private statusSubscription: Subscription;

	constructor(private smsService: SmsService) {}

	ngOnInit(): void {
		// Poll connection status every 30 seconds — one-shot query per tick; a failed tick
		// maps to "disconnected" without killing the stream (#167)
		this.statusSubscription = interval(30000)
			.pipe(
				startWith(0),
				switchMap(() => this.smsService.whatsappConnectionStatus().pipe(catchError(() => of(null))))
			)
			.subscribe((result: any) => {
				this.loading = false;
				const status = result?.data?.whatsappConnectionStatus;
				if (status) {
					this.connectionStatus = status;
					this.smsService.setWaConnected(this.connectionStatus.connected);
				} else {
					this.connectionStatus = { connected: false, lastSeen: null, deviceInfo: null };
					this.smsService.setWaConnected(false);
				}
			});
	}

	ngOnDestroy(): void {
		if (this.statusSubscription) {
			this.statusSubscription.unsubscribe();
		}
	}
}
